<template>
  <MeasurementInput
    v-bind="{label}"
    v-model="modelValue"
    class="HeightInput"
    :minValue="48"
    :maxValue="96"
    :interval="12"
  >
    <template #tick="{ tick }">
      <span class="HeightInput__tickLabel">{{ tick / 12 }}'</span>
    </template>
  </MeasurementInput>
</template>

<script lang="ts" setup>
import formatHeight from "@/lib/utils/string/formatHeight";
import { computed } from "vue";
import MeasurementInput from "./MeasurementInput.vue";

const modelValue = defineModel<number | null>({
  required: true,
});

const label = computed(() => {
  if (modelValue.value === null) return;

  return formatHeight(modelValue.value);
});
</script>

<style lang="scss" scoped>
.HeightInput__tickLabel {
  transform: translateX(0.5ch);
  display: block;
}
</style>
